export default __webpack_public_path__ + "static/media/PK.64fb24bc.svg";